define(
    "diy/undo-redo/plugins/Module",
    [
        'diy/undo-redo/plugins/Base',
        'diy/undo-redo/constants',
        'jquery'
    ],
    /**
     *
     * @param {module.undoRedo.plugins.Base} PluginBase
     * @param {module.undoRedo.constants} constants
     * @param {jQuery} $
     * @returns {*}
     */
    function (PluginBase, constants, $) {
        'use strict';
        var Plugin;
        /**
         * @class module.undoRedo.plugins.Module
         * @template module.undoRedo.plugins.Module
         * @lends {module.undoRedo.plugins.Module.prototype}
         * @extends {module.undoRedo.plugins.Base}
         * @constructor
         */
        Plugin = PluginBase.extend({

            onInit: function () {
                var boundEvents = [
                    'diy-editor-module-inserted-in-page',
                    'diy-editor-module-deleted',
                    'diy-editor-module-saved'
                ].join(' ');

                $(document).bind(boundEvents, function () {
                    this.api.onNewEntryServerSide();
                }.bind(this));

                this.api.attachObserver(function (subject, data) {
                    this.repositionOverlayOnActiveModule();
                }.bind(this), constants.observerTopics.EXECUTION_FINISHED);

                this.markAsReady();
            },
            /**
             *
             * @returns {module.undoRedo.constants.historyEntry.MODULE|*}
             */
            getType: function getType() {
                return [constants.historyEntry.MODULE,constants.historyEntry.MODULE_SECTION];
            },
            repositionOverlayOnActiveModule: function onExecutionFinished(){
                var openedModule = Modul.getActiveModule();
                if (openedModule instanceof Modul) {
                    openedModule.repositionOverlay();
                }
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Module} entry
             */
            onSelect: function onSelect(entry) {
                if (mm[entry.moduleId] && mm[entry.moduleId].modul) {
                    mm[entry.moduleId].modul.toggleClass('undoRedo-highlight', true);
                }
            },
            /**
             *
             * @param {module.undoRedo.HistoryEntry.Base} entry
             */
            onDeselect: function onDeselect(entry) {
                if (mm[entry.moduleId] && mm[entry.moduleId].modul) {
                    mm[entry.moduleId].modul.toggleClass('undoRedo-highlight', false);
                }
            }
        });

        return Plugin;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/plugins/Module.js
 ** module id = 923
 ** module chunks = 0
 **/